import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { emailCitationReport } from "src/common/Scraper";

interface EmailReportPayload {
    reportPdfURI: string;
}

export interface EmailReportResponse {
    status: string;
    message: string;
    response: any;
}

export const useEmailReport = (): UseMutationResult<EmailReportResponse, AxiosError, EmailReportPayload> => {
    return useMutation<EmailReportResponse, AxiosError, EmailReportPayload>({
        mutationFn: emailCitationReport,
    })
};